import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { EmployeesAddModalComponent } from 'src/app/employees/employees-add-modal/employees-add-modal.component';
import { FetchEmployees } from 'src/app/employees/employees.actions';
import { EmployeeState } from 'src/app/employees/employees.state';
import { Employee } from 'src/app/models/Employee';
import { AddRelatedEmployee } from 'src/app/related-employees/related.employees.action';
import { AddProjectEmployee } from 'src/app/projects/project.actions';

@Component({
    selector: 'app-employee-assign-modal',
    templateUrl: './employee-assign-modal.component.html',
    styleUrls: ['./employee-assign-modal.component.scss'],
})
export class EmployeeAssignModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Input() object: any;
    @Select(EmployeeState.Employees) allEmployees$: Observable<Employee[]>;
    @Input() employee: Employee;

    employeeList = '';
    selectedArray: Employee[] = [];
    allEmployees: Employee[];
    availableEmployees: Employee[] = [];
    title: string;
    amountArray: number[] = [];
    keyword = 'firstName';

    actualEmployees: Employee[];
    chosenEmployee: string;
    existingEmployee: Employee;

    constructor(
        private toastr: ToastrService,
        private store: Store,
        private modalService: NgbModal,
        public activeModal: NgbActiveModal,
        private logger: NGXLogger,
    ) {}

    ngOnInit(): void {
        this.logger.debug('Fetching employees');
        this.store.dispatch(new FetchEmployees());
        this.subscriptions.add(
            this.allEmployees$.subscribe((employees) => {
                this.allEmployees = employees;
                const linkedEmployeesCollection = this.isProject() ? this.object.linkedEmployees : this.object.employees;
                if (this.allEmployees && linkedEmployeesCollection) {
                    this.actualEmployees = [...this.allEmployees];
                    linkedEmployeesCollection.forEach((element) => {
                        const employeeUuid = this.isProject() ? element.employee?.uuid : element.uuid;
                        this.actualEmployees = this.actualEmployees.filter((emp) => emp.uuid !== employeeUuid);
                    });
                }
            }),
        );
    }

    fullNameFilter(items: any[], query: string) {
        const results: any[] = [];

        items.forEach((item) => {
            if ((item['firstName'] + ' ' + item['lastName']).toLowerCase().includes(query.toLowerCase())) {
                results.push(item);
            }
        });

        return results;
    }

    selectEvent(item) {
        this.addToEmployeeList(item.uuid);
    }

    addToEmployeeList(uuid: string) {
        this.employeeList = '';
        this.selectedArray.length = 0;

        this.employeeList = this.employeeList.concat(uuid);
        this.selectedArray.push(this.allEmployees.filter((item: Employee) => item.uuid.toLowerCase().includes(uuid))[0]);
    }

    openAddEmployeeModal() {
        this.logger.debug('Opening employeeAddModal');
        this.modalService.open(EmployeesAddModalComponent, {
            windowClass: 'modal-prompt',
        });
    }

    isProject(): boolean {
        return this.object && this.object.linkedEmployees !== undefined && this.object.title !== undefined;
    }

    addNewEmployees() {
        if (this.employeeList == '') {
            this.toastr.error('Please select an employee');
        } else {
            if (this.isProject()) {
                // Handle project employee assignment
                this.logger.debug('Attempt to add employee to project');
                const selectedEmployee = this.selectedArray[0];
                this.subscriptions.add(
                    this.store.dispatch(new AddProjectEmployee(this.object.uuid, selectedEmployee, null)).subscribe(
                        () => {
                            this.logger.debug('Successfully added employee to project');
                            this.toastr.success('Employee added successfully');
                            this.chosenEmployee = '';
                        },
                        (error) => {
                            this.logger.error('Failed to add employee to project');
                            this.toastr.error('Employee already added');
                        },
                    ),
                );
            } else {
                // Handle related employee assignment
                this.logger.debug('Attempt to add relatedEmployee');
                this.subscriptions.add(
                    this.store.dispatch(new AddRelatedEmployee(this.object.uuid, this.employeeList)).subscribe(
                        () => {
                            this.logger.debug('Successfully added relatedEmployee');
                            this.toastr.success('Employee added successfully');
                            this.chosenEmployee = '';
                        },
                        (error) => {
                            this.logger.error('Failed to add relatedEmployee');
                            this.toastr.error('Employee already added');
                        },
                    ),
                );
            }
            this.activeModal.close();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
